import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { entryDetail } from "../../api/accounting";
import { EntryDetail } from "./EntryDetail";

// نافذة تفاصيل القيد: تُحمّل القيد كاملاً بسطوره من الخادم وتُغلق بالخلفية أو Escape.
export const EntryModal = ({ entryId, onClose }) => {
  const { t } = useTranslation();
  const [entry, setEntry] = useState(null);

  useEffect(() => {
    if (!entryId) return;
    setEntry(null);
    entryDetail(entryId).then(setEntry).catch(() => onClose());
  }, [entryId, onClose]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!entryId) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/70 p-4 backdrop-blur-sm sm:p-8"
      data-testid="entry-modal"
      onClick={onClose}
    >
      <div className="w-full max-w-2xl animate-rise-in" onClick={(e) => e.stopPropagation()}>
        <div className="mb-3 flex justify-end">
          <button
            type="button"
            data-testid="entry-modal-close"
            onClick={onClose}
            className="flex items-center gap-2 rounded-2xl bg-background px-4 py-2 text-xs font-bold shadow-neu-sm"
          >
            <X className="h-4 w-4" /> {t("app.close")}
          </button>
        </div>
        {entry ? (
          <EntryDetail entry={entry} />
        ) : (
          <p className="rounded-2xl bg-background p-6 text-center text-sm text-muted-foreground" data-testid="entry-modal-loading">
            {t("app.loading")}
          </p>
        )}
      </div>
    </div>
  );
};
